export default __webpack_public_path__ + "static/media/Icon_awesome_calendar_day.0deaa032.svg";